export default __webpack_public_path__ + "static/media/05.d631c350.png";